import * as React from 'react';
import { cn } from '@/lib/utils';

export const ProjectAvatar = ({
  name,
  logoUrl,
  className,
}: {
  name: string;
  logoUrl?: string | null;
  className?: string;
}) => {
  const [failedUrl, setFailedUrl] = React.useState<string | null>(null);
  const showImage = Boolean(
    logoUrl && logoUrl !== failedUrl && /^https?:\/\//i.test(logoUrl),
  );
  return (
    <span
      className={cn(
        'inline-flex size-10 shrink-0 items-center justify-center overflow-hidden rounded-lg border border-border bg-surface text-sm font-semibold text-ink',
        className,
      )}
    >
      {showImage ? (
        <img
          src={logoUrl!}
          alt=""
          referrerPolicy="no-referrer"
          className="h-full w-full object-contain p-1.5"
          onError={() => setFailedUrl(logoUrl!)}
        />
      ) : (
        name.trim().slice(0, 1).toUpperCase() || 'G'
      )}
    </span>
  );
};
